var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Broken/Home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.39404 8.53098C3.9296 8.36593 4.52131 8.55526 4.85896 9.01953C5.23413 9.53538 5.18974 10.2451 4.75322 10.7101L3.55754 11.5958C2.99099 12.0665 2.6614 12.7635 2.65708 13.5001V27.0069C2.67324 29.2071 4.4572 30.9845 6.65746 30.9925H13.4478V31.022C14.1815 31.022 14.7763 31.6169 14.7763 32.3506C14.7763 33.0843 14.1815 33.6791 13.4478 33.6791H6.65746C2.98402 33.671 0.00811815 30.6951 0 27.0217V13.5001C0.0234865 11.9376 0.756909 10.4707 1.99281 9.51445L3.21802 8.59923L3.39404 8.53098ZM12.0897 1.3513C14.3312 -0.450435 17.5242 -0.450435 19.7657 1.3513L29.966 9.48492C31.1746 10.457 31.8842 11.9195 31.8997 13.4705L31.885 27.0069C31.885 30.6837 28.9043 33.6644 25.2275 33.6644H22.2752C20.4955 33.6644 19.0505 32.226 19.0424 30.4463V24.3351L19.0286 24.1812C18.9561 23.7818 18.6066 23.4789 18.1862 23.4789H13.7578C13.5281 23.4789 13.3081 23.5711 13.1471 23.7348C12.9861 23.8986 12.8976 24.1202 12.9016 24.3498V26.6821C12.9016 27.4159 12.3068 28.0107 11.5731 28.0107C10.8393 28.0107 10.2445 27.4159 10.2445 26.6821V24.3498C10.2445 23.4141 10.6162 22.5168 11.2779 21.8551C11.9395 21.1935 12.8368 20.8218 13.7725 20.8218H18.201C20.1437 20.8299 21.7143 22.4071 21.7143 24.3498V30.4463C21.7143 30.7561 21.9654 31.0073 22.2752 31.0073H25.3013C27.5025 31.0073 29.2869 29.2229 29.2869 27.0217V13.5001C29.2761 12.751 28.9293 12.0464 28.3422 11.5811L18.142 3.44745C16.8557 2.3885 14.9997 2.3885 13.7135 3.44745L10.4364 5.89787C9.82906 6.33403 8.98311 6.19524 8.54694 5.58787C8.11078 4.9805 8.24957 4.13456 8.85694 3.69839L12.0897 1.3513Z",
    fill: "url(#paint0_linear_82_4602)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_4602",
    x1: 0.558245,
    y1: 3.37158e-7,
    x2: 31.7896,
    y2: 32.7577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#EFCE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5DFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.091337f35d399e9ed9426ea1133eea30.svg";
export { ForwardRef as ReactComponent };